import { render, staticRenderFns } from "./tabelaClientes.vue?vue&type=template&id=23ee7e72"
import script from "./tabelaClientes.vue?vue&type=script&lang=js"
export * from "./tabelaClientes.vue?vue&type=script&lang=js"
import style0 from "./tabelaClientes.vue?vue&type=style&index=0&id=23ee7e72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports